import * as React from 'react';
import { FC, useCallback, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { styled, alpha } from '@mui/material/styles';
import {Button, Drawer, IconButton, Tooltip, Typography, Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress} from '@mui/material';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PreviewIcon from '@mui/icons-material/RemoveRedEye';
import DeleteIcon from '@mui/icons-material/Delete';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ShareIcon from '@mui/icons-material/Share';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
// import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CloseIcon from '@mui/icons-material/Close';
import ThermalPrintDialog from '../ThermalPrintDialog/ThermalPrintDialog';
import AuditTimeline from '../AuditTimeline/AuditTimeline';

import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { AEstimate } from '../../utils/estimate.types';
import DialogRecievePaymentForm from '../DialogPaymentSettlementForm/DialogRecievePaymentForm';
import DialogPaymentSettlementForm from '../DialogPaymentSettlementForm/DialogPaymentSettlementForm';
import DialogAddPaymentForm from '../Cashflow/DialogAddPaymentForm';
import { fetchInvoicesWithoutState, updateInvoiceStatus, deleteInvoice, deletePaymentReceipt } from '../../store/invoiceStore/invoiceThunk';
import { deleteVendorPayment,  } from '../../store/CashOutflowStore/cashOutflowThunk';
import DialogShareInvoiceReciept from '../../components/DialogShareInvoiceReciept/DialogShareInvoiceReciept';
import { AInvoice } from '../../utils/invoice.types';
import { Utils, InvoiceRoute, VocuherCategory, VocuherTypes } from "../../utils/common-utils";
import { PermissionMenuItem, PermissionIconButton } from '../Permission';
import useModuleAccess from '../../hooks/useModuleAccess';
import { red } from '@mui/material/colors';
import { toast } from 'react-toastify';

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

interface estimateActionProp {
  type: string;
  row: AEstimate;
  actionChangeHandler?: (data: any) => void;
  showInlineAction?: boolean;
  /**
   * Query string of the filters the listing is currently showing. Handed to the
   * preview so its prev/next walks the same list the user opened the invoice from,
   * instead of every invoice in the account.
   */
  listFilters?: string;
}

const CustomizedEstimateMenus: FC<estimateActionProp> = ({ type, row, actionChangeHandler, showInlineAction, listFilters}) => {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { permissions, selectedAccount } = useAppSelector(state => state.auth);

  const { accountDetails } = useAppSelector(state => state.account);

  const currentPathName = window.location.href;
  const curPage = currentPathName.split('/');

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [openShareDrawer, setOpenShareDrawer] = useState<boolean>(false);
  const [openRecivePaymentDrawer, setOpenRecivePaymentDrawer] = useState<boolean>(false);
  const [selectedInvoices, setSelectedInvoices] = useState<AEstimate[]>([]);
  const [saleId, setSaleId] = useState<string>(row._id);
  const [saleType, setSaleType] = useState<string>(row.voucherCategory || '');
  const [invoiceType, setInvoiceType] = useState<string>("");
  const [salePdfUrlLocation, setSalePdfUrlLocation] = useState<any>(row.pdfUrlLocation);
  const [selectedBuyer, setSelectedBuyer] = useState<any>();
  const [saleModuleType, setSaleModuleType] = useState<string>(row.voucherType || 'Invoice');

  // This menu is shared by Sales and Purchases (and estimates / credit notes);
  // the two are distinguished at runtime only by voucherCategory, so permission
  // checks have to resolve the module the same way.
  const permModule = row.voucherCategory === VocuherCategory.PURCHASE ? 'purchases' : 'sales';

  // The inline icon-bar variant (invoice preview / navigation bar) offers the
  // same actions as the dropdown, so it is gated on the same permissions. The
  // dropdown uses PermissionMenuItem; icon buttons just go disabled.
  const { can } = useModuleAccess();
  const canEditVoucher = can(permModule, 'edit');
  const canCreateVoucher = can(permModule, 'create');
  const canRecordPayment = can('payments', 'create');
  const canDeleteReceipts = can('payments', 'delete');
  const [shareType, setShareType] = useState<any>();
  const [isCompRefresh, setIsCompRefresh] = useState(false);

  // const [refresh, setRefresh] = useState<boolean>(true);

  // Thermal print dialog state
  const [thermalPrintOpen, setThermalPrintOpen] = useState(false);
  const [selectedInvoiceForPrint, setSelectedInvoiceForPrint] = useState<AEstimate | null>(null);

  // Delete confirmation dialog state
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  // Audit log dialog state
  const [auditDialogOpen, setAuditDialogOpen] = useState<boolean>(false);

  const handleOpenAudit = (event: any) => {
    setAuditDialogOpen(true);
    event.stopPropagation();
    handleClose();
  };

  const handleCloseAudit = () => {
    setAuditDialogOpen(false);
  };

  // Delete receipts confirmation dialog state
  const [openDeleteReceiptsDialog, setOpenDeleteReceiptsDialog] = useState<boolean>(false);
  const [isDeletingReceipts, setIsDeletingReceipts] = useState<boolean>(false);
  const [receiptDeleteInvoiceId, setReceiptDeleteInvoiceId] = useState<string>('');
  const [receiptDeleteVCategory, setReceiptDeleteVCategory] = useState<string>('');

  // Open thermal print dialog
  const handleThermalPrint = useCallback((invoice: AEstimate) => {
    setSelectedInvoiceForPrint(invoice);
    setThermalPrintOpen(true);
    handleClose();
  }, []);

  // Generate thermal content (kept for backward compatibility)
  const generateThermalContent = (invoice: AEstimate) => {
    const businessName = selectedAccount?.name || 'Business';
    const businessPhone = selectedAccount?.whatsAppNumber || '';
    const businessAddress = selectedAccount?.location?.address || '';
    
    return `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Thermal Receipt</title>
          <style>
            @page { size: 58mm auto; margin: 2mm; }
            body {
              font-family: monospace;
              font-size: 8pt;
              line-height: 1.2;
              margin: 0;
              padding: 2mm;
              width: 54mm;
            }
            .header { text-align: center; border-bottom: 2px solid #000; padding-bottom: 2mm; margin-bottom: 2mm; }
            .business-name { font-weight: bold; font-size: 10pt; margin-bottom: 1mm; }
            .section { margin-bottom: 2mm; border-bottom: 1px dotted #999; padding-bottom: 1mm; }
            .total { font-weight: bold; text-align: center; padding: 2mm; border: 2px solid #000; margin: 2mm 0; }
            @media print { body { margin: 0; padding: 1mm; } }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="business-name">${businessName}</div>
            ${businessAddress ? <div>${businessAddress}</div> : ''}
            ${businessPhone ? <div>Ph: ${businessPhone}</div> : ''}
            <div>================================</div>
            <div><strong>${invoice.voucherType?.toUpperCase()}</strong></div>
            <div>Bill: ${(invoice as any).invoiceNumber || 'N/A'}</div>
            <div>${new Date().toLocaleDateString('en-IN')} ${new Date().toLocaleTimeString('en-IN')}</div>
          </div>
          
          <div class="section">
            <div><strong>BILL TO:</strong></div>
            <div>${invoice.client?.name || invoice.supplier?.name || 'Customer'}</div>
            ${invoice.client?.phone || invoice.supplier?.phone ? <div>${invoice.client?.phone || invoice.supplier?.phone}</div> : ''}
          </div>
          
          <div class="section">
            <div><strong>ITEMS:</strong></div>
            ${(invoice as any).lineItems?.map((item: any, i: number) => `
              <div style="margin: 1mm 0;">
                <div>${item.description || item.name || 'Item ' + (i + 1)}</div>
                <div>${item.qty || 1} x ${Utils.formatNumber(item.appliedRate || item.rate || 0)} = ${Utils.formatNumber(item.total || 0)}</div>
              </div>
            `).join('') || <div>Service: ${Utils.formatNumber(invoice.amount || 0)}</div>}
          </div>
          
          <div class="total">
            TOTAL: ₹${Utils.formatNumber(invoice.amount || 0)}
          </div>
          
          <div style="text-align: center; margin-top: 2mm; border-top: 2px dashed #000; padding-top: 2mm;">
            <div>Thank You!</div>
            <div>Powered by iBook</div>
          </div>
        </body>
      </html>
    `;
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleViewInvoiceClick = useCallback(({ _id, status, pdfTemplate, voucherCategory }: AEstimate) => {
    // Call edit function
    let navLink = '';
    let path = 'invoice';
    console.log("============= ", type);
    if (type == 'sale-estimate') {
      path = `estimate`;
    } else if (type == 'sale-credit-note') {
      // TODO: Make Common flow for all moduels for view invoice
      path = `estimate`;
    } else if (type == 'sale-debit-note') {
      path = `estimate`;
    } else if (type == 'sale-delivery-note') {
      path = `delivery-note`;
    }
    // navLink = `/sales/${path}/${_id}/view?templateId=${pdfTemplate}&type=${type}&pdfLocation=${salePdfUrlLocation.Location}`;
    navLink = `/invoice/${_id}/preview?templateId=${pdfTemplate}&type=${voucherCategory}`;
    // Carry the listing's filters so the preview navigates the same set of invoices.
    if (listFilters) navLink += `&listFilters=${encodeURIComponent(listFilters)}`;
    navigate(navLink);
    // window.open(navLink, '_blank');
  }, [listFilters]);

  const handleEditInvoiceClick = useCallback(({ _id, status, pdfTemplate, voucherType, voucherCategory }: AEstimate) => {
    // Call edit function
    let navLink = '';
    let type = voucherCategory ? voucherCategory : VocuherCategory.SALE;
    let navEditLink = '';
    console.log(type);
    console.log(voucherType);
    let invoiceMeta = Utils.getInvoiceRouteName(voucherType || '');
    navEditLink = `/${type}/invoice/${invoiceMeta.routeName}/edit/${_id}`
    if (navEditLink != '') navigate(navEditLink);
  }, []);

  // const handleOpenShareDrawer = (event: any) => {
  //   console.log(" OpenShare drawer called");
  //   setSelectedBuyer(row.buyer);
  //   setOpenShareDrawer(true);
  //   event.stopPropagation();
  //   handleClose()
  // };

  const handleOpenShareDrawer = (event: any, shareTypeCheck: string) => {
    console.log("OpenShare drawer called");
    console.log(row);
    setSelectedBuyer(row.client);
    setShareType(shareTypeCheck);
    setSaleId(row._id);
    if ( shareTypeCheck == 'Payment Receipt') {
      console.log(row.receiptPdfUrlLocation);
      setSalePdfUrlLocation(row.receiptPdfUrlLocation);
    } else {
      setSalePdfUrlLocation(row.pdfUrlLocation);
    }
    setOpenShareDrawer(true);
    event.stopPropagation();
    handleClose()
  };

  const handleCloseShareDrawer = () => {
    console.log("====== Debuging handleCloseShareDrawer called =====>");
    setSelectedBuyer('');
    setOpenShareDrawer(false);
    // navigate("/sales/estimate");
    // actionChangeHandler = true;
    console.log("setting up refreshCompOnClose ====>")
    console.log(actionChangeHandler)
  };

  const handleRecievePayment = (event: any) => {
    setOpenRecivePaymentDrawer(true);
    console.log(selectedInvoices);
    event.stopPropagation();
  }

  const handleClosPaymentDrawer = () => {
    setSelectedInvoices([]);
    setOpenRecivePaymentDrawer(false);
    if(actionChangeHandler) {
      actionChangeHandler({ isRefersh: Math.random().toString()});
    }
  };

  const openPaymentDrawer = (e: any, invoiceData: any) => {
    // For purchases, use supplier; for sales, use client
    const party = invoiceData.voucherCategory === VocuherCategory.PURCHASE ? invoiceData.supplier : invoiceData.client;
    console.log("openPaymentDrawer - party:", party);
    console.log("openPaymentDrawer - invoiceData:", invoiceData);
    setSelectedBuyer(party);

    setSelectedInvoices([invoiceData])

    let queryString = "filter=" + party._id;
    queryString += "&status=PENDING,PARTIALLY_PAID";
    handleRecievePayment(e);
    setAnchorEl(null);
  };

  const handleViewPaymentReceiptClick = useCallback(({ _id, status, receiptPdfTemplate }: AEstimate) => {
    let navLink = '';
    let type = '';
    if (curPage.includes('account-payable')) {
        type = 'AP';
    } else {
        type = 'AR';
    }

    navLink = `/invoice-payment-receipt/${_id}/view?templateId=${receiptPdfTemplate}&type=${type}`;
    navigate(navLink);
  }, []);

  const handleNewTransaction = (vCategory: string, vType: string, _refInvoiceId: string = '', _refVoucherType='', _copy=false) => {
    let redirectTo = '';
    const invoiceMeta = Utils.getInvoiceRouteName(vType);
    if (vCategory && vType){
        redirectTo = `/${vCategory}/invoice/${invoiceMeta.routeName}/create`;
    }
    if (vCategory && vType && _refInvoiceId != '' && _refVoucherType != '') {
      redirectTo = `/${vCategory}/invoice/${invoiceMeta.routeName}/create?_ref=${_refInvoiceId}&_reftype=${_refVoucherType}&_copy=${_copy}`;
    }
    navigate(redirectTo);
  };

  const handleChangeInvoiceStatus = (invoiceId: string, status: string) => {
    let data = {
      id: invoiceId,
      invoiceStatus: status
    }
    dispatch(updateInvoiceStatus(data))
    if(actionChangeHandler) {
      actionChangeHandler({ isRefersh: Math.random().toString()});
    }
    handleClose()
  };

  // const handleDeleteInvoice = (invoiceId: string) => {
  //   dispatch(deleteInvoice(invoiceId))
  //   if(actionChangeHandler) {
  //     actionChangeHandler({ isRefersh: Math.random().toString()});
  //   }
  //   handleClose()
  // };

  const handleDeleteInvoicePayments = (invoiceId: string, vCategory: string) => {
    console.log("Calling api for vcategory", vCategory, VocuherCategory.SALE)
    setReceiptDeleteInvoiceId(invoiceId);
    setReceiptDeleteVCategory(vCategory);
    setOpenDeleteReceiptsDialog(true);
    handleClose();
  };

  const handleConfirmDeleteReceipts = async () => {
    setIsDeletingReceipts(true);
    try {
      if (receiptDeleteVCategory == VocuherCategory.SALE) {
        console.log("Calling api for sales");
        await dispatch(deletePaymentReceipt(receiptDeleteInvoiceId));
      } else {
        console.log("Calling api for purchase");
        await dispatch(deleteVendorPayment(receiptDeleteInvoiceId));
      }
      if (actionChangeHandler) {
        console.log("actionChangeHandler called to refresh the page")
        actionChangeHandler({ isRefersh: Math.random().toString() });
      }
    } catch (error) {
      console.error('Error deleting receipts:', error);
    } finally {
      setIsDeletingReceipts(false);
      setOpenDeleteReceiptsDialog(false);
      setReceiptDeleteInvoiceId('');
      setReceiptDeleteVCategory('');
    }
  };

  const handleCloseDeleteReceiptsDialog = () => {
    setOpenDeleteReceiptsDialog(false);
    setReceiptDeleteInvoiceId('');
    setReceiptDeleteVCategory('');
  };

  // Close thermal print dialog
  const handleCloseThermalDialog = useCallback(() => {
    setThermalPrintOpen(false);
    setSelectedInvoiceForPrint(null);
  }, []);

  // Delete invoice handlers
  const handleDeleteClick = (event: any) => {
    setOpenDeleteDialog(true);
    event.stopPropagation();
    handleClose();
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleConfirmDelete = async () => {
    setIsDeleting(true);
    try {
      await dispatch(deleteInvoice(row._id)).unwrap();
      setOpenDeleteDialog(false);
      setIsDeleting(false);
      // Toast is already shown by Redux slice - no need to show it here
      // Refresh the invoice list
      if(actionChangeHandler) {
        actionChangeHandler({ isRefersh: Math.random().toString()});
      }
    } catch (error: any) {
      console.error('Error deleting invoice:', error);
      setIsDeleting(false);
      // Error toast is shown here as Redux doesn't show error details
      toast.error('Failed to delete invoice: ' + (error.message || 'Unknown error'));
    }
  };

  return (
    <div>
      {showInlineAction ? 
      <>
        {row.status == "DRAFT" &&
        <>
          <PermissionIconButton module={permModule} action="edit"
            title={`Edit ${row.voucherType}`}
            deniedMessage={`You do not have permission to edit ${row.voucherType}`}
            onClick={(e) => handleEditInvoiceClick(row)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: 20 }}
            size='small'>
            <EditIcon color="info" style={{ fontSize: 20 }} />
          </PermissionIconButton>
          <IconButton onClick={(e) => handleOpenShareDrawer(e, row.voucherType)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Share ${row.voucherType} ${row.status == 'DRAFT' ? '(Draft)': '(Published)'} `}><ShareIcon color="success" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          {(row.voucherType == VocuherTypes.PROFORMA_INVOICE || row.voucherType == VocuherTypes.ESTIMATE ) && 
            <>
              <PermissionIconButton module={permModule} action="create"
                title={`Create Invoice from ${row.voucherType}`}
                deniedMessage="You do not have permission to create invoices"
                onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.GST_INVOICE, row._id, VocuherTypes.ESTIMATE, false)}
                style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
                size='small'>
                <ContentCopyIcon color="warning" style={{ fontSize: 20 }} />
              </PermissionIconButton>
            </>
          }
          <PermissionIconButton module={permModule} action="edit"
            title={`Mark as ${row.voucherCategory == VocuherCategory.PURCHASE ? 'Recieved': 'Sent'} `}
            deniedMessage={`You do not have permission to edit ${row.voucherType}`}
            onClick={(e) => handleChangeInvoiceStatus(row._id, "PENDING")}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <KeyboardDoubleArrowUpIcon style={{ fontSize: 20, color: "#2188ef" }} />
          </PermissionIconButton>
        </>
        }
        {(row.status == "PENDING" || row.status == "Invoice Sent") &&
        <>
          <PermissionIconButton module={permModule} action="edit"
            title={`Edit ${row.voucherType}`}
            deniedMessage={`You do not have permission to edit ${row.voucherType}`}
            onClick={(e) => handleEditInvoiceClick(row)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <EditIcon color="info" style={{ fontSize: 20 }} />
          </PermissionIconButton>
          <IconButton onClick={(e) => handleOpenShareDrawer(e, row.voucherType)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Share ${row.voucherType}`}><ShareIcon color="success" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          {(row.voucherType == VocuherTypes.PROFORMA_INVOICE || row.voucherType == VocuherTypes.ESTIMATE ) && 
            <>
              <PermissionIconButton module={permModule} action="create"
                title={`Create Invoice from ${row.voucherType}`}
                deniedMessage="You do not have permission to create invoices"
                onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.GST_INVOICE, row._id, VocuherTypes.ESTIMATE, false)}
                style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
                size='small'>
                <ContentCopyIcon style={{ fontSize: 20 }} />
              </PermissionIconButton>
            </>
          }
          {(row.voucherCategory == VocuherCategory.SALE && 
            row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
            row.voucherType != VocuherTypes.ESTIMATE ) &&
            <PermissionIconButton module="payments" action="create"
              title={`Record Payment In`}
              deniedMessage="You do not have permission to record payments"
              onClick={(e) => openPaymentDrawer(e, row)}
              style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
              size='small'>
              <PaymentIcon style={{ fontSize: 20 }} />
            </PermissionIconButton>
          }
          {/* {(row.voucherCategory == VocuherCategory.PURCHASE && 
            row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
            row.voucherType != VocuherTypes.ESTIMATE ) && 
            <IconButton disabled={!canRecordPayment} onClick={(e) => openPaymentDrawer(e, row)}
              style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
              size='small' disabled>
              <Tooltip arrow title={`Record Payment Out`}><PaymentIcon style={{ fontSize: 20 }} /></Tooltip>
            </IconButton>
          } */}
        </>
        }
        {row.status == "PARTIALLY_PAID" &&
        <>
          <IconButton onClick={(e) => handleOpenShareDrawer(e, row.voucherType)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Share ${row.voucherType}`}><ShareIcon color="success" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          {(row.voucherCategory == VocuherCategory.SALE && 
            row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
            row.voucherType != VocuherTypes.ESTIMATE ) &&
            <PermissionIconButton module="payments" action="create"
              title={`Record Payment In`}
              deniedMessage="You do not have permission to record payments"
              onClick={(e) => openPaymentDrawer(e, row)}
              style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
              size='small'>
              <PaymentIcon style={{ fontSize: 20 }} />
            </PermissionIconButton>
          }
          {/* {(row.voucherCategory == VocuherCategory.PURCHASE && 
            row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
            row.voucherType != VocuherTypes.ESTIMATE ) && 
            <IconButton disabled={!canRecordPayment} onClick={(e) => openPaymentDrawer(e, row)}
              style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
              size='small'>
              <Tooltip arrow title={`Record Payment Out`}><PaymentIcon style={{ fontSize: 20 }} /></Tooltip>
            </IconButton>
          } */}
          {(row.voucherType != VocuherTypes.PROFORMA_INVOICE  ) && 
            <>
              <IconButton onClick={(e) => handleViewPaymentReceiptClick(row)}
                style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
                size='small'>
                <Tooltip arrow title={`View Receipts`}><ReceiptLongIcon style={{ fontSize: 20 }} /></Tooltip>
              </IconButton>
              <IconButton onClick={(e) => handleOpenShareDrawer(e, 'Payment Receipt')}
                style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
                size='small'>
                <Tooltip arrow title={`Share Receipts`}><ShareIcon color="success" style={{ fontSize: 20 }} /></Tooltip>
              </IconButton>
              <PermissionIconButton module="payments" action="delete"
                title={`Delete All Receipts`}
                deniedMessage="You do not have permission to delete payment receipts"
                onClick={(e) => handleDeleteInvoicePayments(row._id, row.voucherCategory)}
                style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
                size='small'>
                <DeleteIcon color="error" style={{ fontSize: 20 }} />
              </PermissionIconButton>
            </>
            }
        </>
        }
        {row.status == 'INVOICED' &&
          <>
            <IconButton onClick={(e) => handleViewInvoiceClick(row)}
              style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
              size='small'>
              <Tooltip arrow title={`Share ${row.voucherType}`}><ShareIcon color="success" style={{ fontSize: 20 }} /></Tooltip>
            </IconButton>
          </>
        }
        {(row.status == 'OVER_PAID' || row.status == 'PAID' ) &&
        <>
          <IconButton onClick={(e) => handleOpenShareDrawer(e, row.voucherType)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Share ${row.voucherType}`}><ShareIcon color="info" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          <IconButton onClick={(e) => handleViewPaymentReceiptClick(row)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`View Receipts`}><ReceiptLongIcon color="info" style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          <IconButton onClick={(e) => handleOpenShareDrawer(e, 'Payment Receipt')}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Share Receipts`}><ShareIcon style={{ fontSize: 20 }} /></Tooltip>
          </IconButton>
          <PermissionIconButton module="payments" action="delete"
            title={`Delete All Receipts`}
            deniedMessage="You do not have permission to delete payment receipts"
            onClick={(e) => handleDeleteInvoicePayments(row._id, row.voucherCategory)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <ReceiptLongIcon color="error" style={{ fontSize: 20 }} />
          </PermissionIconButton>
        </>
        }
        {(row.voucherType && row.voucherCategory ) && 
          <PermissionIconButton module={permModule} action="create"
            title={`Make a copy`}
            deniedMessage={`You do not have permission to create ${row.voucherType}`}
            onClick={(e) => handleNewTransaction(row.voucherCategory, row.voucherType, row._id, row.voucherType, true)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <ContentCopyIcon style={{ fontSize: 20 }} />
          </PermissionIconButton>
        }
        <IconButton onClick={(e) => handleThermalPrint(row)}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Thermal Print ${row.voucherType}`}><LocalPrintshopIcon style={{ fontSize: 20, color: '#6b7280' }} /></Tooltip>
          </IconButton>
          <IconButton onClick={handleOpenAudit}
            style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: 0, marginRight: 20, marginLeft: -5 }}
            size='small'>
            <Tooltip arrow title={`Audit Log`}><AssignmentIcon style={{ fontSize: 20, color: '#6b7280' }} /></Tooltip>
          </IconButton>
        </>
      :
        <>
        <Button
          variant="contained" size='small'
          style={{ marginRight: '10px', color:'#488dff',backgroundColor:'#fff',border:'1px solid #488dff',borderRadius:10 }}
          id="demo-customized-button"
          aria-controls={open ? 'demo-customized-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          disableElevation
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
        >
          Actions
        </Button>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            'aria-labelledby': 'demo-customized-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >
          
          {row.status == "DRAFT" &&
            <div>
            <PermissionMenuItem module={permModule} action="edit" onClick={(e) => handleEditInvoiceClick(row)} disableRipple>
              <EditIcon color="primary"/>
              Edit {saleModuleType}
            </PermissionMenuItem>
            <MenuItem onClick={(e) => handleViewInvoiceClick(row)} disableRipple>
              <PreviewIcon color='primary'/>  
              View {saleModuleType}
            </MenuItem>
            <MenuItem onClick={(e) => handleOpenShareDrawer(e, saleModuleType)} disableRipple>
              <ShareIcon color='primary'/>
              Share {saleModuleType} {row.status == "DRAFT"? '(Draft)': '(Published)'}
            </MenuItem>
            {(row.voucherType == VocuherTypes.PROFORMA_INVOICE || row.voucherType == VocuherTypes.ESTIMATE ) && 
              <>
                <PermissionMenuItem module={permModule} action="create" onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.GST_INVOICE, row._id, VocuherTypes.ESTIMATE, false)} disableRipple>
                  <ContentCopyIcon color='primary'/>
                  Create Invoice
                </PermissionMenuItem>
              </>
            }
            <PermissionMenuItem module={permModule} action="edit" onClick={(e) => handleChangeInvoiceStatus(row._id, "PENDING")} disableRipple>
              <DoneAllIcon color='primary' style={{color: "#2188ef"}}/>
              Mark as {row.voucherCategory == VocuherCategory.PURCHASE ? "Recieved ":"Sent"}
            </PermissionMenuItem>
            </div>
          }

          {(row.status == "PENDING" || row.status == "Invoice Sent") &&
            <div>
            <PermissionMenuItem module={permModule} action="edit" onClick={(e) => handleEditInvoiceClick(row)} disableRipple>
              <EditIcon color="primary"/>
              Edit {saleModuleType}
            </PermissionMenuItem>
            <MenuItem onClick={(e) => handleViewInvoiceClick(row)} disableRipple>
              <PreviewIcon color='primary'/>  
              View {saleModuleType}
            </MenuItem>
            <MenuItem onClick={(e) => handleOpenShareDrawer(e, saleModuleType)} disableRipple>
              <ShareIcon color='primary'/>
              Share {saleModuleType}
            </MenuItem>
            {(row.voucherType == VocuherTypes.PROFORMA_INVOICE || row.voucherType == VocuherTypes.ESTIMATE ) && 
              <>
                <PermissionMenuItem module={permModule} action="create" onClick={(e) => handleNewTransaction(VocuherCategory.SALE, InvoiceRoute.GST_INVOICE, row._id, VocuherTypes.ESTIMATE, false)} disableRipple>
                  <ContentCopyIcon color='primary'/>
                  Create Invoice
                </PermissionMenuItem>
              </>
            }
            {(row.voucherCategory == VocuherCategory.SALE && 
              row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
              row.voucherType != VocuherTypes.ESTIMATE ) && 
              <PermissionMenuItem module="payments" action="create" deniedMessage="You do not have permission to record payments" onClick={(e) => openPaymentDrawer(e, row)} disableRipple>
                <PaymentIcon color='success'/>
                Record Payment In
              </PermissionMenuItem>
            }
            {(row.voucherCategory == VocuherCategory.PURCHASE && 
              row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
              row.voucherType != VocuherTypes.ESTIMATE ) && 
              <PermissionMenuItem module="payments" action="create" deniedMessage="You do not have permission to record payments" onClick={(e) => openPaymentDrawer(e, row)} disableRipple>
                <PaymentIcon color='success'/>
                Record Payment Out
              </PermissionMenuItem>
            }
            </div>
          }

          {row.status == "PARTIALLY_PAID" &&
            <div>
            <MenuItem onClick={(e) => handleViewInvoiceClick(row)} disableRipple>
              <PreviewIcon color='primary'/>  
              View {saleModuleType}
            </MenuItem>
            <MenuItem onClick={(e) => handleOpenShareDrawer(e, saleModuleType)} disableRipple>
              <ShareIcon color='primary'/>
              Share {saleModuleType}
            </MenuItem>
            {(row.voucherCategory == VocuherCategory.SALE &&
              row.voucherType != VocuherTypes.ESTIMATE &&
              row.voucherType != VocuherTypes.PROFORMA_INVOICE) &&
              <PermissionMenuItem module="payments" action="create" deniedMessage="You do not have permission to record payments" onClick={(e) => openPaymentDrawer(e, row)} disableRipple>
                <PaymentIcon color='success'/>
                Record Payment In
              </PermissionMenuItem>
            }
            {(row.voucherCategory == VocuherCategory.PURCHASE && 
              row.voucherType != VocuherTypes.PROFORMA_INVOICE && 
              row.voucherType != VocuherTypes.ESTIMATE ) && 
              <PermissionMenuItem module="payments" action="create" deniedMessage="You do not have permission to record payments" onClick={(e) => openPaymentDrawer(e, row)} disableRipple>
                <PaymentIcon color='success'/>
                Record Payment Out
              </PermissionMenuItem>
            }
          
            {(row.voucherType != VocuherTypes.PROFORMA_INVOICE  ) && 
              <>
                <MenuItem onClick={(e) => handleViewPaymentReceiptClick(row)} disableRipple>
                  <ReceiptLongIcon color='primary'/>
                  View Receipts
                </MenuItem>
                <MenuItem onClick={(e) => handleOpenShareDrawer(e, 'Payment Receipt')} disableRipple>
                  <ShareIcon color='primary'/>
                  Share Receipts
                </MenuItem>
                <PermissionMenuItem module="payments" action="delete" deniedMessage="You do not have permission to delete payment receipts" onClick={(e) => handleDeleteInvoicePayments(row._id, row.voucherCategory)} disableRipple>
                  <DeleteIcon color='error' style={{color: '#e74c3c'}}/>
                  Delete All Receipts
                </PermissionMenuItem>
              </>
            }
            </div>
          }

          {row.status == 'INVOICED' &&
            <div>
              <MenuItem onClick={(e) => handleViewInvoiceClick(row)} disableRipple>
                <PreviewIcon color='primary'/>  
                View {saleModuleType}
              </MenuItem>
              <MenuItem onClick={(e) => handleOpenShareDrawer(e, saleModuleType)} disableRipple>
                <ShareIcon color='primary'/>
                Share {saleModuleType}
              </MenuItem>
            </div>
          }

          {(row.status == 'OVER_PAID' || row.status == 'PAID' ) &&
            <div>
            <MenuItem onClick={(e) => handleViewInvoiceClick(row)} disableRipple>
              <PreviewIcon color='primary'/>  
              View {saleModuleType}
            </MenuItem>
            <MenuItem onClick={(e) => handleOpenShareDrawer(e, saleModuleType)} disableRipple>
              <ShareIcon color='primary'/>
              Share {saleModuleType}
            </MenuItem>
            <MenuItem onClick={(e) => handleViewPaymentReceiptClick(row)} disableRipple>
              <ReceiptLongIcon color='primary'/>
              View Receipts
            </MenuItem>
            <MenuItem onClick={(e) => handleOpenShareDrawer(e, 'Payment Receipt')} disableRipple>
              <ShareIcon color='primary'/>
              Share Receipts
            </MenuItem>
            <PermissionMenuItem module="payments" action="delete" deniedMessage="You do not have permission to delete payment receipts" onClick={(e) => handleDeleteInvoicePayments(row._id, row.voucherCategory)} disableRipple>
              <DeleteIcon color='error' style={{color: '#e74c3c'}}/>
                Delete All Receipts
            </PermissionMenuItem>
            </div>
          }
  {/* 
          {row.status == "PARTIALLY_PAID" &&
            <div>
            <MenuItem onClick={(e) => handleInvoiceNoClick(row)} disableRipple>
              <PreviewIcon color='success' />  
              View Invoice
            </MenuItem>
            <MenuItem onClick={(e) => openPaymentDrawer(e, row)} disableRipple>
              <PaymentIcon color='success'/>
              Receive Payment
            </MenuItem>
            <MenuItem onClick={(e) => handleViewPaymentReceiptClick(row)} disableRipple>
              <ReceiptIcon color='primary'/>
              View Payment Receipt
            </MenuItem>
            </div>
            
          }

          {(row.status == 'OVER_PAID' || row.status == 'PAID' ) &&
            <div>
            <MenuItem onClick={(e) => handleInvoiceNoClick(row)} disableRipple>
              <PreviewIcon />  
              View Invoice
            </MenuItem>
            <MenuItem onClick={(e) => handleViewPaymentReceiptClick(row)} disableRipple>
              <ReceiptIcon />
              View Payment Receipt
            </MenuItem>
            </div>
          } */}
          
          <Divider sx={{ my: 0.5 }} />
          <div>
            {(row.voucherType && row.voucherCategory ) &&
              <>
                <PermissionMenuItem module={permModule} action="create" onClick={(e) => handleNewTransaction(row.voucherCategory, row.voucherType, row._id, row.voucherType, true)} disableRipple>
                  <ContentCopyIcon color='primary'/>
                  Make a copy
                </PermissionMenuItem>
              </>
            }
            <MenuItem onClick={(e) => handleThermalPrint(row)} disableRipple>
              <LocalPrintshopIcon style={{ color: '#6b7280' }}/>
              Thermal Print {saleModuleType}
            </MenuItem>
            <MenuItem onClick={handleOpenAudit} disableRipple>
              <AssignmentIcon style={{color: '#6b7280'}}/>
              Audit Log
            </MenuItem>
            <PermissionMenuItem module={permModule} action="delete" onClick={handleDeleteClick} disableRipple>
              <DeleteIcon style={{color: '#e74c3c'}}/>
              Delete {saleModuleType}
            </PermissionMenuItem>
          </div>
          
        </StyledMenu>
        </>
      }

      <Drawer
          disableEscapeKeyDown={false}
          anchor="right"
          onClose={handleClosPaymentDrawer}
          open={openRecivePaymentDrawer}>
          {row.voucherCategory === VocuherCategory.PURCHASE ? (
            <DialogAddPaymentForm
                title="Add New Payment Out"
                isInflow={false}
                preSelectedParty={selectedBuyer}
                onClose={handleClosPaymentDrawer}
                open={openRecivePaymentDrawer}>
            </DialogAddPaymentForm>
          ) : (
            <DialogRecievePaymentForm
                selectedInvoices={selectedInvoices}
                selectedBuyer={selectedBuyer}
                onClose={handleClosPaymentDrawer}
                open={openRecivePaymentDrawer}>
            </DialogRecievePaymentForm>
          )}
      </Drawer>

      <Drawer
        disableEscapeKeyDown={false}
        anchor="right"
        onClose={handleCloseShareDrawer}
        open={openShareDrawer}>
        <DialogShareInvoiceReciept
            dispatchType={shareType}
            invoiceId={saleId}
            invoicePreviewData={salePdfUrlLocation}
            onClose={handleCloseShareDrawer}
            selectedBuyer={selectedBuyer}
            openDrawer={openShareDrawer}>
        </DialogShareInvoiceReciept>
      </Drawer>
      {selectedInvoiceForPrint && (
        <ThermalPrintDialog
          open={thermalPrintOpen}
          onClose={handleCloseThermalDialog}
          invoice={selectedInvoiceForPrint}
          businessName={selectedAccount?.name || 'Business'}
          businessPhone={selectedAccount?.whatsAppNumber || ''}
          businessAddress={selectedAccount?.location?.address || ''}
        />
      )}

      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
          }
        }}
        sx={{
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(4px)',
          },
        }}
      >
        <DialogTitle
          id="delete-dialog-title"
          sx={{
            backgroundColor: '#fef2f2',
            borderBottom: '1px solid #fecaca',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            py: 3,
            px: 3
          }}
        >
          <Box sx={{
            backgroundColor: '#fee2e2',
            borderRadius: '50%',
            p: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <DeleteIcon sx={{ color: '#dc2626', fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, color: '#1f2937', fontSize: '1.25rem', lineHeight: 1.2 }}>
              Delete {saleModuleType}
            </Typography>
            <Typography variant="body2" sx={{ color: '#6b7280', mt: 0.5, fontSize: '0.875rem' }}>
              This action cannot be undone
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ py: 4, px: 3 }}>
          <Typography variant="body1" sx={{ color: '#1f2937', fontSize: '1.125rem', fontWeight: 400, lineHeight: 1.7, pt: 2, pb: 1, mb: 3 }}>
            Are you sure you want to delete {saleModuleType} <strong>{(row as any).invoiceNumber}</strong>?
          </Typography>
          <Typography variant="body2" sx={{ color: '#6b7280', fontSize: '0.95rem', lineHeight: 1.6, mb: 3, fontWeight: 600 }}>
            This Will Permanently Remove The {saleModuleType} Record, All Line Items, Attachments, Associated Payments, And Journal Entries.
          </Typography>

          <Box sx={{
            backgroundColor: '#fef3c7',
            border: '1px solid #f59e0b',
            borderRadius: 2,
            p: 3,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 2
          }}>
            <Box sx={{
              backgroundColor: '#fbbf24',
              borderRadius: '50%',
              p: 0.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 24,
              height: 24
            }}>
              <Typography sx={{ color: '#ffffff', fontSize: '0.875rem', fontWeight: 'bold' }}>!</Typography>
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#92400e', fontSize: '0.875rem', mb: 0.5 }}>
                Important Warning
              </Typography>
              <Typography variant="body2" sx={{ color: '#92400e', fontSize: '0.875rem', lineHeight: 1.5 }}>
                All data linked to this {saleModuleType.toLowerCase()} will also be removed. This data cannot be recovered once deleted.
              </Typography>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{
          backgroundColor: '#f9fafb',
          borderTop: '1px solid #e5e7eb',
          px: 3,
          py: 2.5,
          gap: 1.5
        }}>
          <Button
            onClick={handleCloseDeleteDialog}
            disabled={isDeleting}
            variant="outlined"
            sx={{
              minWidth: 100,
              height: 40,
              textTransform: 'none',
              fontWeight: 500,
              borderColor: '#d1d5db',
              color: '#374151',
              '&:hover': { borderColor: '#6b7280', backgroundColor: '#e5e7eb', color: '#1f2937' }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            disabled={isDeleting}
            startIcon={isDeleting ? <CircularProgress size={18} color="inherit" /> : <DeleteIcon sx={{ fontSize: 18 }} />}
            sx={{
              minWidth: 140,
              height: 40,
              textTransform: 'none',
              fontWeight: 600,
              backgroundColor: '#dc2626',
              '&:hover': { backgroundColor: '#b91c1c' },
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'
            }}
          >
            {isDeleting ? 'Deleting...' : `Delete ${saleModuleType}`}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Audit Log Drawer (opens from the right) */}
      <Drawer
        anchor="right"
        open={auditDialogOpen}
        onClose={handleCloseAudit}
        PaperProps={{ sx: { width: { xs: '100%', sm: 560 }, maxWidth: '100%' } }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 2, px: 3, backgroundColor: '#f5f5f5', borderBottom: '1px solid #e5e7eb' }}>
            <AssignmentIcon sx={{ color: '#6b7280', fontSize: 26 }} />
            <Box sx={{ flex: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#111827', fontSize: '1.1rem' }}>Audit Logs</Typography>
              {(row as any).invoiceNumber && (
                <Typography variant="body2" sx={{ fontWeight: 600, color: '#6b7280' }}>
                  #{(row as any).invoiceNumber}
                </Typography>
              )}
            </Box>
            <IconButton size="small" onClick={handleCloseAudit}><CloseIcon /></IconButton>
          </Box>
          <Box sx={{ flex: 1, overflowY: 'auto', py: 2, px: 2 }}>
            <AuditTimeline entity="Invoice" entityId={row._id} />
          </Box>
        </Box>
      </Drawer>

      {/* Delete Receipts Confirmation Dialog */}
      <Dialog
        open={openDeleteReceiptsDialog}
        onClose={handleCloseDeleteReceiptsDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
          }
        }}
        sx={{
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            backdropFilter: 'blur(4px)',
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: '#fef2f2',
            borderBottom: '1px solid #fecaca',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            py: 3,
            px: 3
          }}
        >
          <Box sx={{
            backgroundColor: '#fee2e2',
            borderRadius: '50%',
            p: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <DeleteIcon sx={{ color: '#dc2626', fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, color: '#1f2937', fontSize: '1.25rem', lineHeight: 1.2 }}>
              Delete All Receipts
            </Typography>
            <Typography variant="body2" sx={{ color: '#6b7280', mt: 0.5, fontSize: '0.875rem' }}>
              This action cannot be undone
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ py: 4, px: 3 }}>
          <Typography variant="body1" sx={{ color: '#1f2937', fontSize: '1.125rem', fontWeight: 400, lineHeight: 1.7, pt: 2, pb: 1, mb: 3 }}>
            Are you sure you want to delete all payment receipts for <strong>{(row as any).invoiceNumber}</strong>?
          </Typography>
          <Typography variant="body2" sx={{ color: '#6b7280', fontSize: '0.95rem', lineHeight: 1.6, mb: 3, fontWeight: 600 }}>
            This Will Permanently Remove All Payment Receipts And Associated Journal Entries For This {saleModuleType}.
          </Typography>

          <Box sx={{
            backgroundColor: '#fef3c7',
            border: '1px solid #f59e0b',
            borderRadius: 2,
            p: 3,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 2
          }}>
            <Box sx={{
              backgroundColor: '#fbbf24',
              borderRadius: '50%',
              p: 0.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 24,
              height: 24
            }}>
              <Typography sx={{ color: '#ffffff', fontSize: '0.875rem', fontWeight: 'bold' }}>!</Typography>
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#92400e', fontSize: '0.875rem', mb: 0.5 }}>
                Important Warning
              </Typography>
              <Typography variant="body2" sx={{ color: '#92400e', fontSize: '0.875rem', lineHeight: 1.5 }}>
                All payment receipts linked to this {saleModuleType.toLowerCase()} will be removed. This data cannot be recovered once deleted.
              </Typography>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions sx={{
          backgroundColor: '#f9fafb',
          borderTop: '1px solid #e5e7eb',
          px: 3,
          py: 2.5,
          gap: 1.5
        }}>
          <Button
            onClick={handleCloseDeleteReceiptsDialog}
            disabled={isDeletingReceipts}
            variant="outlined"
            sx={{
              minWidth: 100,
              height: 40,
              textTransform: 'none',
              fontWeight: 500,
              borderColor: '#d1d5db',
              color: '#374151',
              '&:hover': { borderColor: '#6b7280', backgroundColor: '#e5e7eb', color: '#1f2937' }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDeleteReceipts}
            variant="contained"
            disabled={isDeletingReceipts}
            startIcon={isDeletingReceipts ? <CircularProgress size={18} color="inherit" /> : <DeleteIcon sx={{ fontSize: 18 }} />}
            sx={{
              minWidth: 140,
              height: 40,
              textTransform: 'none',
              fontWeight: 600,
              backgroundColor: '#dc2626',
              '&:hover': { backgroundColor: '#b91c1c' },
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'
            }}
          >
            {isDeletingReceipts ? 'Deleting...' : 'Delete Receipts'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


export default CustomizedEstimateMenus;
